import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Text } from '@bonanza-social/moonlight';
import { selectPrizeWallCampaignName } from '../../../state/prizeWallCampaign/prizeWallCampaign.slice';
import { PrizeWallInfoHeaderProps } from './PrizeWallInfoHeader.types';
import PrizeWallHeaderBase from '../../common/PrizeWallHeaderBase/PrizeWallHeaderBase';
import PrizeWallTokensInfo from '../../PrizeWallTokensInfo/PrizeWallTokensInfo';

function PrizeWallInfoHeader(props: PrizeWallInfoHeaderProps) {
  const campaignName = useSelector(selectPrizeWallCampaignName);

  return (
    <PrizeWallHeaderBase
      backgroundColor={{
        mobile: 'transparent',
        tablet: 'screenBackground',
        desktop: 'screenBackground',
      }}
      {...props}
    >
      <Text variant="body-m" color="darkSurfacePrimary" textAlign="center">
        {campaignName}
      </Text>
      <PrizeWallTokensInfo />
    </PrizeWallHeaderBase>
  );
}

export default memo(PrizeWallInfoHeader);
